import LinkAnalyticIndex from '../components/LinkAnalytic/Index'
import LinkAnalyticDetail from '../components/LinkAnalytic/Detail'

export default [
  {
    path: '/client/link-analytics',
    name: 'link-analytic-index',
    component: LinkAnalyticIndex,
    meta: {
      sideMenuId: 'link-analytic',
    },
  },
  {
    path: '/client/link-analytics/:id',
    name: 'link-analytic-detail',
    component: LinkAnalyticDetail,
    meta: {
      sideMenuId: 'link-analytic',
    },
  },
]
